<template>
  <div>
    <MdtNotify />
    <StzhUnprotectedViewHeader v-if="isLSZTemplateActive" sticky="always-full" />
    <div
      class="application-form"
      :class="{ lsz: formTemplate === 'lsz' }">
      <div v-if="!isLSZTemplateActive" class="header-helper" :style="headerHelperStyles" />
      <UnprotectedViewHeader v-if="!isLSZTemplateActive" />
      <RouterView />
      <UnprotectedViewFooter
        v-if="!isLSZTemplateActive && formsSettingsLoaded"
        :left="formsSettings.product_form_left_footer"
        :right="formsSettings.product_form_right_footer"
        :datenschutz="formsSettings.product_form_data_protection" />
    </div>
    <StzhUnprotectedViewFooter v-if="isLSZTemplateActive" />
  </div>
</template>

<script>
import UnprotectedViewHeader from '@/components/unprotected-view/UnprotectedViewHeader.vue';
import UnprotectedViewFooter from '@/components/unprotected-view/UnprotectedViewFooter.vue';
import { APPLICATION_FORM } from '@/utility/constants';
import StzhUnprotectedViewHeader from '@/components/unprotected-view/StzhUnprotectedViewHeader.vue';
import StzhUnprotectedViewFooter from '@/components/unprotected-view/StzhUnprotectedViewFooter.vue';

export default {
  name: 'ApplicationForm',
  components: {
    StzhUnprotectedViewFooter,
    StzhUnprotectedViewHeader,
    UnprotectedViewHeader,
    UnprotectedViewFooter,
  },
  computed: {
    formsSettings() {
      return this.$store.getters['applicationForm/getFormsSettings'];
    },
    formsSettingsLoaded() {
      return Object.keys(this.formsSettings).length;
    },
    formTemplate() {
      const bootstrapFormSettings = this.$store.getters
        .bootstrap?.settings?.uiConfig?.applicationForm;
      return bootstrapFormSettings?.template || '';
    },
    isLSZTemplateActive() {
      return this.formTemplate === APPLICATION_FORM.TEMPLATE.CITY_OF_ZURICH;
    },
    headerHelperStyles() {
      let height;
      switch (this.$route.name) {
        case 'CreateAdult':
          height = '125px';
          break;
        case 'LandingPage':
        case 'UpdateApplicationForm':
          height = '120px';
          break;
        default:
          height = '225px';
          break;
      }
      return { height };
    },
  },
};
</script>

<style lang="scss" scoped>
.application-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background: $stzh-back-light;
  padding: 0 40px;

  &.lsz ::v-deep :is(h1, h2, h3, h4, h5, h6) {
    font-family: $stzh-font-heavy;
  }
  &.lsz ::v-deep :is(
    .info-text,
    .field-label,
    .has-error,
    .form-info-text p,
    .form-info-text div,
    .form-info-text ol,
    .form-info-text ul,
    .form-info-text span,
    .unprotected-view-footer) {
    font-family: $stzh-font-regular;
  }

  .header-helper {
    position: fixed;
    width: 100%;
    height: 225px;
    background: $stzh-back-light;
    z-index: 10;
  }

  ::v-deep .unprotected-view-header {
    max-width: $application-form-max-width;
    position: fixed;
    z-index: 601; // STZH Design System is 600
    background: $stzh-back-light;
  }
  ::v-deep .footer-info-left {
    p:first-child {
      font-size: 14px !important;
    }
  }
}
@media only screen and (max-width: 912px) {
  ::v-deep .unprotected-view-header {
    max-width: calc(100% - 80px) !important; // 40px padding on each side
  }
}
@media only screen and (max-width: 411px) {
  .application-form {
    padding: 0 24px;
  }

  ::v-deep .unprotected-view-header {
    max-width: calc(100% - 48px) !important; // 24px padding on each side
  }
}
</style>
